import moment from 'moment';
import { arzoooS3Url } from './checkMode';

export function isMobile() {
  return window.innerWidth <= 800;
}
export function capitalizeOnlyFirstLetter(str) {
  str = str.toLowerCase();
  const arrOfWords = str.split(' ');
  const arrOfWordsCased = [];

  for (let i = 0; i < arrOfWords.length; i++) {
    const char = arrOfWords[i].split('');
    char[0] = char[0].toUpperCase();

    arrOfWordsCased.push(char.join(''));
  }
  return arrOfWordsCased.join(' ');
}

export function CapitalizeFirstLetter(letter) {
  return letter.charAt(0).toUpperCase() + letter.slice(1);
}
export const handleTypeNumber = (e) => {
  let checkIfNum;
  if (e.key !== undefined) {
    checkIfNum = e.key === 'e' || e.key === 'E' || e.key === '.' || e.key === '+' || e.key === '-';
  }
  return checkIfNum && e.preventDefault();
};
export const debounceFunction = (func, delay) => {
  let timer;
  return function () {
    let self = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(self, args);
    }, delay);
  };
};
export const getFormattedData = (data, headers) => {
  let formattedData = [];
  data.forEach((item) => {
    let temp = {};
    Object.keys(headers).forEach((key) => {
      if (!item[key]) {
        temp[key] = '-';
      } else {
        temp[key] =
          key === 'assignedAt'
            ? convertDateAndTime(item.assignedAt)
            : key === 'piLink'
            ? `${invoiceImgUrl()}${item.piLink}`
            : item[key];
      }
    });
    formattedData.push(temp);
  });
  return formattedData;
};

export const getFileHeader = (headerList) => {
  let headers = {};
  headerList.forEach((item) => {
    headers[item.id] = item.label;
  });
  return headers;
};

export const formateDate1 = (date, format) => {
  return moment(new Date(date)).format(format);
};
export const convertDateAndTime = (time) => {
  let assignedTime = new Date(time);
  assignedTime = assignedTime.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  return assignedTime;
};
export const formatDate = (value) => {
  let assignedTime = new Date(value);
  assignedTime = assignedTime.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  return assignedTime;
};
//function to convert date
export const convertDate = (str) => {
  let date = new Date(str),
    month = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
  return [date.getFullYear(), month, day].join('-');
};

//function to fetch banner file url
export const getBannerBaseUrl = () => {
  // if (window.location.href.indexOf('test') > -1 || window.location.href.indexOf('localhost') > -1) {
  //   return 'https://homeyantra-test-static.s3.ap-south-1.amazonaws.com/images/falcon-popup-banners/';
  // } else {
  //   return 'https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com/images/falcon-popup-banners/';
  // }
  return arzoooS3Url + '/images/falcon-popup-banners/';
};

export const getBannerUrl = () => {
  // if (window.location.href.indexOf('test') > -1 || window.location.href.indexOf('localhost') > -1) {
  //   return 'https://homeyantra-test-static.s3.ap-south-1.amazonaws.com/images/falcon_banners/';
  // } else {
  //   return 'https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com/images/falcon_banners/';
  // }
  return arzoooS3Url + '/images/falcon_banners/';
};

//function to fetch invoice file url
export const invoiceImgUrl = () => {
  // if (window.location.href.indexOf('test') > -1 || window.location.href.indexOf('localhost') > -1) {
  //   return 'https://homeyantra-test-static.s3.ap-south-1.amazonaws.com/images/supplier_pi/';
  // } else {
  //   return 'https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com/images/supplier_pi/';
  // }
  return arzoooS3Url + '/images/supplier_pi/';
};

//function to fetch debit note file url
export const dnImgUrl = () => {
  // if (window.location.href.indexOf('test') > -1 || window.location.href.indexOf('localhost') > -1) {
  //   return 'https://homeyantra-test-static.s3.ap-south-1.amazonaws.com/images/falcon_dn/';
  // } else {
  //   return 'https://arzooo-static-prod-v2.s3.ap-south-1.amazonaws.com/images/falcon_dn/';
  // }
  return arzoooS3Url + '/images/falcon_dn/';
};

export const containsSpace = (value) =>
  value && (value.endsWith(' ') || value.startsWith(' ')) ? 1 : 0;

export const checkForNumberAndCommas = (value) => /^[0-9,\s]*$/.test(value);

export const checkForNumber = (value) => /^[0-9]*$/.test(value);

export const checkAPISuccess = (response) => {
  if (response?.data?.status === 'success') {
    return true;
  } else return false;
};

export const checkBtnClick = (downloadObj, downloadReportLoader) =>
  downloadObj.fromDate && downloadObj.toDate && !downloadReportLoader;
export const checkDisable = (downloadObj, downloadReportLoader) =>
  downloadReportLoader || !downloadObj.fromDate || !downloadObj.toDate;

export const currrentMonthStart = formateDate1(moment().startOf('month'), 'YYYY-MM-DD');
export const currentMonthEnd = formateDate1(moment().endOf('month'), 'YYYY-MM-DD');

export const MILISECONDS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_HOURS = SECONDS_IN_MINUTE * MINUTES_IN_HOUR;
export const MILISECONDS_IN_MINUTE = MILISECONDS_IN_SECOND * SECONDS_IN_MINUTE;
export const HOURS_IN_DAY = 24;
